<div class="modal fade" id="dialogContratoLicitacao" data-backdrop="static" data-keyboard="false" tabindex="-1"
  role="dialog">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white">
        <h5 class="modal-title" style="font-size: 1rem;">Cadastro de Contratos para licitação</h5>
        <button type="button" class="close" (click)="fechar()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-2" *ngIf="entidade?.licitacao">
        <form [formGroup]="entidadeForm" autocomplete="off">
          <div class="form-row">
            <div class="col-md-6">
              <p-selectButton [options]="tipos" formControlName="tipo" optionValue="id">
                <ng-template let-tipo>
                  <span class="p-2">{{tipo.nome}}</span>
                </ng-template>
              </p-selectButton>
            </div>
          </div>
          <hr />
          <div class="form-row">
            <div class="form-group form-group-sm col-md-3">
              <label>N˚ Licitação</label>
              <span class="form-control">{{entidade.licitacao.numero | LICITACAO}}</span>
            </div>
            <div class="form-group form-group-sm col-md-3">
              <label>N˚ Processo</label>
              <span class="form-control">{{entidade.licitacao.processo | LICITACAO}}</span>
            </div>
            <div class="form-group form-group-sm col-md-6">
              <label>Modalidade</label>
              <span class="form-control">{{entidade.licitacao.modalidade.nome}}</span>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group form-group-sm col-md-9">
              <label>Favorecido</label>
              <span class="form-control">{{entidade.favorecido.cpf_cnpj | CPF}} - {{entidade.favorecido.nome}}</span>
            </div>
            <div class="form-group form-group-sm col-md-3">
              <label>Valor Contrato</label>
              <span class="form-control font-weight-bold text-primary text-right">
                {{entidade.valor_contrato | number:'1.2-2'}}
              </span>
            </div>
          </div>
          <hr />
          <div class="form-row">
            <div class="form-group form-group-sm col-md-3">
              <label class="required">Nº Contrato</label>
              <input formControlName="numero" type="text" [unmask]="true"
                [imask]="{mask: [ {mask: '0000/0000'}, {mask: '00000/0000'} ]}" class="form-control">
            </div>
            <div class="form-group form-group-sm col-md-3">
              <label class="required">Tipo de Contrato</label>
              <select [compareWith]="compareFn" formControlName="tipo_contrato" class="custom-select">
                <option [value]="item.id" *ngFor="let item of listaTipos">
                  {{item.nome}}
                </option>
              </select>
            </div>
            <div class="form-group form-group-sm col-md-6">
              <label class="required">Contratação</label>
              <select [compareWith]="compareFn" formControlName="tipo_contratacao" class="custom-select">
                <option [value]="item.id" *ngFor="let item of listaContratacao">
                  {{item.nome}}
                </option>
              </select>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group form-group-sm col-md-3">
              <label class="required">Assinatura</label>
              <p-calendar formControlName="data_assinatura" inputStyleClass="form-control" dataType="date"
                dateFormat="dd/mm/yy" [showOnFocus]="true" [showButtonBar]="true">
              </p-calendar>
            </div>
            <div class="form-group form-group-sm col-md-3">
              <label class="required">Início</label>
              <p-calendar formControlName="data_inicio" inputStyleClass="form-control" dataType="date"
                dateFormat="dd/mm/yy" [showOnFocus]="true" [showButtonBar]="true">
              </p-calendar>
            </div>
            <div class="form-group form-group-sm col-md-3">
              <label class="required">Término</label>
              <p-calendar formControlName="data_termino" inputStyleClass="form-control" dataType="date"
                dateFormat="dd/mm/yy" [showOnFocus]="true" [showButtonBar]="true">
              </p-calendar>
            </div>
            <div class="form-group form-group-sm col-md-3">
              <label class="required">Prazo</label>
              <select [compareWith]="compareFn" name="selectTipo" formControlName="prazo" class="custom-select">
                <option [ngValue]="item" *ngFor="let item of listaPrazos">{{item.nome}}</option>
              </select>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group form-group-sm col-12">
              <label class="required">Objeto</label>
              <textarea formControlName="objeto" class="form-control" rows="5"></textarea>
            </div>
          </div>
          <div class="form-row">
            <div class="col-12">
              <table class="table table-sm table-eddy mb-0">
                <thead>
                  <tr>
                    <th scope="col" style="width: 75%">Item</th>
                    <th scope="col" class="text-center">Qtd.</th>
                    <th scope="col" class="text-center">Valor Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of entidade.itens">
                    <td>
                      {{funcaoService.abreviarStr(item?.descricao, 67, true)}} {{item.unidade}}
                    </td>
                    <td class="text-right">{{+item.quantidade | number:'1.0-0'}}</td>
                    <td class="text-right">{{+item.valor_total | number:'1.2-2'}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </form>
        <!-- <pre>{{entidadeForm?.value|json}}</pre> -->
      </div>
      <div class="modal-footer">
        <div class="row" style="width: 100%;">
          <div class="col-4 pl-0">
            <button (click)="submitForm()" type="button" class="btn btn-sm btn-primary"
              [disabled]="!entidadeForm.valid">
              <i class="fa fa-check"></i> Salvar
            </button>
          </div>
          <div class="col-2 offset-6 text-right">
            <button type="button" class="btn btn-sm btn-link" (click)="fechar()">Cancelar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>